import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Button,
  
} from '@mui/material';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import { billRecycle, billRestore } from '../../../Services/Services';

import Popover from '@mui/material/Popover';


const BillRestore = () => {
    const [bill, setbill] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [billToDelete, setbillToDelete] = useState(null);

    useEffect(() => {
        const billListApi = async () => {
            try {
                const response = await billRecycle(); // don't pass any argument if not needed
                setbill(response);
                console.log("bill fetched successfully:", response);
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        };

        billListApi();
    }, []);



    const handleDelete = async (bill_id) => {
        try {
            const response = await billRestore(bill_id); // don't pass any argument if not needed
            setbill(response);
        } catch (error) {
            console.error("Error fetching branch:", error);
        }
    };

  function formatOnlyDate(dateTimeString, format = "dd-mm-yyyy") {
    const date = new Date(dateTimeString);

    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();

    if (format === "dd-mm-yyyy") {
      return `${day}-${month}-${year}`;
    } else if (format === "yyyy-mm-dd") {
      return `${year}-${month}-${day}`;
    } else {
      throw new Error("Unsupported format. Use 'dd-mm-yyyy' or 'yyyy-mm-dd'.");
    }
  }

  const getInitials = (str) => {
    return str
      .split(' ')
      .filter(word => word)
      .map(word => word[0])
      .join('')
      .toUpperCase();
  };



    return (
        <Box>
            {/* Filter + Sort + Count + Buttons */}

            {bill.length === 0 ? (
                <Typography>No bill found.</Typography>
            ) : (
                <div id="branch-table-print">
                    <TableContainer sx={{ overflowX: "auto", maxWidth: "100%" }}>
                        <Table size="small" sx={{ "& td, & th": { borderBottom: "1px solid #ccc" } }}>
                            <TableHead>
                                <TableRow sx={{ backgroundColor: "#f5f5f5", "& th": { fontWeight: "bold", color: "#333", borderBottom: "1px solid #999", whiteSpace: "nowrap" } }}>
                                    <TableCell>Sr. No.</TableCell>
                                                <TableCell>Ref No</TableCell>
                                                <TableCell>Party Name</TableCell>
                                                <TableCell>Branch Name</TableCell>
                                                <TableCell>Freight Id</TableCell>
                                                <TableCell>Bill Date</TableCell>
                                                <TableCell>Total Amt</TableCell>
                                                <TableCell>Rec Amt</TableCell>
                                                <TableCell>Bal Amt</TableCell>
                                                   <TableCell>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {bill.map((row, index) => {

                                    return (
                                        <TableRow
                                            key={index}
                                            sx={{
                                                backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff", // alternate row color
                                                "& td": {
                                                    paddingTop: "0px",
                                                    paddingBottom: "0px",
                                                    fontSize: "0.8125rem",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    maxWidth: 120,
                                                    color: (theme) =>
                                                        theme.palette.mode === "dark" ? "white" : "inherit",
                                                    backgroundColor: (theme) =>
                                                        theme.palette.mode === "dark" ? "black" : "inherit",
                                                },
                                            }}
                                        >
                                             <TableCell>{index + 1}</TableCell>
                                                              <TableCell>{row.branch_name === 'RAIPUR' ? 'SRE' : row.branch_name === 'BILASPUR' ? 'JHT' : 'MBR'}/{row.billing_id}/{getInitials(row.party_name)}</TableCell>
                                                              <TableCell>{row.party_name}</TableCell>
                                                              <TableCell>{row.branch_name}</TableCell>
                                                              <TableCell>
                                                                {Array.isArray(row.freight_id)
                                                                  ? row.freight_id.join(", ")
                                                                  : row.freight_id}
                                                              </TableCell>
                                                              <TableCell>{formatOnlyDate(row.created_at)}</TableCell>
                                                              <TableCell>{(row.total_amount).toFixed(2)}</TableCell>
                                                              <TableCell>{(row.paid_amount).toFixed(2)}</TableCell>
                                                              <TableCell>{(row.rem_amount).toFixed(2)}</TableCell>
                                            <TableCell align="center" className="no-print">
                                                <IconButton
                                                    onClick={(e) => {
                                                        setAnchorEl(e.currentTarget);
                                                        setbillToDelete(row.billing_id);
                                                    }}
                                                    color="error"
                                                    size="small"
                                                >
                                                   <RestoreFromTrashIcon fontSize="small" style={{color:"blue"}}/>
                                                </IconButton>

                                             
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            )}



            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <Box sx={{ p: 1 }}>
                    <Typography variant="body2">Are you sure?</Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                        <Button
                            color="error"
                            size="small"
                            onClick={async () => {
                                try {
                                    await handleDelete(billToDelete); // don't pass any argument if not needed
                                } finally {
                                    setAnchorEl(null);
                                    setbillToDelete(null);
                                }
                            }}
                        >
                            Yes
                        </Button>
                        <Button
                            size="small"
                            onClick={() => {
                                setAnchorEl(null);
                                setbillToDelete(null);
                            }}
                        >
                            No
                        </Button>
                    </Box>
                </Box>
            </Popover>



        </Box>
    );
};

export default BillRestore;
